<template>
  <div class="valuation-inline" :class="{ 'valuation-inline--muted': muted, 'valuation-inline--highlight': highlight }">
    <span class="valuation-inline__label">{{ label }}</span>
    <span class="valuation-inline__value">${{ (value || 0).toLocaleString() }}</span>
  </div>
</template>

<script setup>
// One book value in the valuation strip — a label over a dollar figure.
//
// `mute` became `muted`: it reads as a verb otherwise, and this is a state.
defineOptions({ name: 'ValuationInline' });

defineProps({
  label: { type: String, required: true },
  value: { type: Number, default: 0 },
  // The figure the clerk is actually pricing against — MMR on this strip.
  highlight: { type: Boolean, default: false },
  // Present but secondary, like a reserve the clerk cannot act on directly.
  muted: { type: Boolean, default: false },
});
</script>

<style scoped>
.valuation-inline {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: var(--p-valuation-inline-padding);
}

.valuation-inline--muted {
  opacity: 0.75;
}

.valuation-inline__label {
  font-size: var(--p-valuation-inline-label-font-size);
  font-weight: var(--p-valuation-inline-label-font-weight);
  letter-spacing: var(--p-valuation-inline-label-letter-spacing);
  color: var(--p-valuation-inline-label-color);
  text-transform: uppercase;
}

.valuation-inline__value {
  font-family: var(--p-valuation-inline-value-font-family);
  font-size: var(--p-valuation-inline-value-font-size);
  font-weight: var(--p-valuation-inline-value-font-weight);
  letter-spacing: var(--p-valuation-inline-value-letter-spacing);
  line-height: var(--p-valuation-inline-value-line-height);
  color: var(--p-valuation-inline-value-color);
  font-variant-numeric: tabular-nums;
}

.valuation-inline--highlight .valuation-inline__label {
  color: var(--p-valuation-inline-highlight-label-color);
}

.valuation-inline--highlight .valuation-inline__value {
  color: var(--p-valuation-inline-highlight-value-color);
}
</style>
